import { ActionPayload, ID } from "../../types";
import * as types from "../constants/ActionTypes";

export interface DisabledSinglePayload {
  id: ID;
}
export interface DisabledMultiplePayload {
  ids: ID[];
}
export const addDisabled = (id: ID): ActionPayload<DisabledSinglePayload> => {
  return {
    type: types.ADD_DISABLED,
    payload: {
      id,
    },
  };
};

export const removeDisabled = (
  id: ID
): ActionPayload<DisabledSinglePayload> => {
  return {
    type: types.REMOVE_DISABLED,
    payload: {
      id,
    },
  };
};

export const addMultipleDisabled = (
  ids: ID[]
): ActionPayload<DisabledMultiplePayload> => {
  return {
    type: types.ADD_MULTIPLE_DISABLED,
    payload: {
      ids,
    },
  };
};

export const removeMultipleDisabled = (
  ids: ID[]
): ActionPayload<DisabledMultiplePayload> => {
  return {
    type: types.REMOVE_MULTIPLE_DISABLED,
    payload: {
      ids,
    },
  };
};
